import script from "./AddContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContactModal.vue?vue&type=script&setup=true&lang=js"

import "./AddContactModal.vue?vue&type=style&index=0&id=6ec022ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec022ca"]])

export default __exports__